import { defineComponent, computed } from '@vue/composition-api';
import { BfSpinner } from 'components/Butterfly';
import Icon from 'src/components/Icon.vue';
const ThemesTab = defineComponent({
    components: {
        BfSpinner,
        Icon,
    },
    props: {
        isLoading: { type: Boolean, required: false, default: true },
        themes: { type: Array, required: false, default: () => [] },
        data: { type: Array, required: false, default: () => [] },
        selectedThemeID: {
            type: [String, Number, null],
            default: null,
        },
        hasChanges: {
            type: Object,
            required: false,
            default: () => ({}),
        },
    },
    setup(props) {
        const getPercentage = computed(() => {
            return props.themes.reduce((acc, theme) => ({
                ...acc, [theme.id]: parseFloat(((props.data.find((qs) => qs.name === theme.name)?.coverage ?? 0) * 100).toFixed(2))
            }), {});
        });
        const savedThemes = computed(() => {
            return props.themes.filter((theme) => !theme.is_new);
        });
        const newThemes = computed(() => {
            return props.themes.filter((theme) => theme.is_new);
        });
        return {
            getPercentage,
            savedThemes,
            newThemes,
        };
    }
});
export default ThemesTab;
